export function formatChallengeDisplay(n: number | null | undefined): string {
	if (n == null) return '0';
	const v = Number(n);
	if (!Number.isFinite(v) || v <= 0) return '0';
	return String(Math.floor(v)).padStart(2, '0');
}

/** Converts a 0-based index to a 1-based challenge number. */
export function indexToChallengeNumber1Based(index: unknown): number | null {
	const n = typeof index === 'number' ? index : parseInt(String(index ?? ''), 10);
	if (!Number.isFinite(n) || n < 0) return null;
	return Math.floor(n) + 1;
}

